import { Flex, Box, AspectRatio } from "@chakra-ui/react";
import React from "react";
import Image, { type StaticImageData } from "next/legacy/image";
import { trackEvent } from "lib/analytics";
import { Button } from "ui/button";
import { TextTitle } from "ui/text";
import { Section } from "./section";

type SolutionsPartnersHeroProps = {
  title: string;
  image?: StaticImageData | string;
  imageAlt?: string;
  description?: string;
};

export function SolutionsPartnersHero({ title, image, imageAlt, description }: SolutionsPartnersHeroProps) {
  return (
    <Section my="huge">
      <Flex justify="space-between" direction={{ base: "column", lg: "row" }} gap={{ base: 12, xl: "big" }}>
        <TextTitle
          size="lg"
          titleAs="h1"
          title={title}
          description={description}
          descriptionAs="h2"
          actions={
            <>
              <Button
                variant="secondary"
                href="https://docs.google.com/forms/d/e/1FAIpQLSex2W4-ZoRIN1E-rDDm4NPFAbllde88rj4q1uuBrrBUDCMPWA/viewform"
                onClick={() => {
                  trackEvent("Solutions Partners Form CTA clicked");
                }}
              >
                Become a partner
              </Button>

              <Button
                hasRightChevron
                href="/solutions-partners/directory"
                onClick={() => {
                  trackEvent("Solutions Partners Directory CTA clicked");
                }}
              >
                View partner directory
              </Button>
            </>
          }
        />

        {image && (
          <Box
            pos="relative"
            w="100%"
            maxW={{ base: "560px", lg: "500px" }}
            borderRadius="6px"
            overflow="hidden"
            alignSelf="center"
          >
            <AspectRatio ratio={2 / 1} w="100%">
              <Image
                priority
                src={typeof image === "string" ? image : image.src}
                alt={imageAlt ?? "Hero image."}
                layout="fill"
                objectFit="contain"
              />
            </AspectRatio>
          </Box>
        )}
      </Flex>
    </Section>
  );
}
